<template>
  <label class="bb-checkbox" :class="classCheckbox" @click.stop>
    <span class="bb-checkbox-container"
          :class="{
      'bb-checkbox-container_disabled': disabled,
      'bb-checkbox-container_top': topPosition
    }">
      <input class="bb-checkbox-container__input"
             :class="{'bb-checkbox-container__input_red' : styles}"
             v-model="statusCheckbox"
             type="checkbox"
             :disabled="disabled"
             :name="name">
       <span class="bb-checkbox-container__checkmark-wrapper"
             :class="{
         'bb-checkbox-container__checkmark-wrapper_animation': animation,
         'bb-checkbox-container__checkmark-wrapper_red' : styles
       }">
         <div v-if="choseChecked" class="bb-checkbox-container__icon-chose"/>
         <i v-else class="icon-check bb-checkbox-container__checkmark"/>
      </span>
    </span>
    <span class="bb-checkbox__text"
          :class="{
            'bb-checkbox__text_filter': filter,
            'bb-checkbox__text_flag': flag,
            'bb-checkbox__text_size': styleText
          }"
          v-if="checkboxText">
      <CountryFlag class="bb-checkbox__flag" v-if="flag" :countryId="flag" :hidePopup="true"/>
      {{ checkboxText }}
    </span>
    <slot v-else></slot>
  </label>
</template>
<script>

import CountryFlag from '@/components/Main/CountryFlag/CountryFlag'

export default {
  name: 'checkbox',
  props: [
    'value',
    'name',
    'section',
    'checkboxText',
    'styleText',
    'classCheckbox',
    'styles',
    'disabled',
    'animation',
    'topPosition',
    'choseChecked',
    'filter',
    'flag'
  ],
  components: {
    CountryFlag
  },
  computed: {
    statusCheckbox: {
      get: function () {
        return this.value
      },
      set: function (data) {
        this.$emit('checkboxChange', data, this.name, this.section)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../../sass/variables";

  .bb-checkbox {
    position: relative;
    display: inline-flex;
    min-height: 14px;

    &-container {
      position: relative;
      cursor: pointer;
      width: 14px;
      min-width: 14px;

      &_disabled {
        pointer-events: none;
      }

      &_top {
        top: 6px;
      }

      &__icon-chose {
        width: 8px;
        height: 2px;
        background-color: $color-white;
      }

      &__checkmark-wrapper {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 14px;
        width: 14px;
        border: 1px solid $color-accent;
        box-sizing: border-box;
        border-radius: 3px;
        background-color: $color-white;
        transition: .15s ease-out;

        &_red {
          border: 1px solid $color-crimson;
        }

        &_animation {
          height: 16px;
          width: 16px;
          animation: fromCircle .2s ease-in-out 1;
        }
      }

      &__checkmark {
        display: flex;
        font-size: 0;
        color: $color-white;
        transition: .15s ease-out;
      }

      &__input {
        position: absolute;
        top:0;
        left: 0;
        height: 14px;
        width: 14px;
        margin: 0;
        opacity: 0;

        &:checked + span {
          background-color: $color-accent;

          i {
            font-size: 6px;
          }
        }

        &_red {
          &:checked + span {
            background-color: $color-crimson;
          }
        }
      }

    }

    &__text {
      margin-left: 8px;
      font-size: 12px;
      line-height: 14px;
      cursor: pointer;

      &_filter {
        color: $color-black;
        font-size: 13px;
        line-height: 16px;
        font-weight: lighter;
      }

      &_size {
        position: relative;
        bottom: 3px;
        font-size: 15px;
        line-height: 18px;
      }

      &_flag {
        display: flex;
        align-items: center;
      }
    }

    &__flag {
      height: 16px;
      margin-top: -8px;
      margin-right: 5px;
    }
  }

  @keyframes fromCircle {
    from {
      border-radius: 50%;
    }
    50% {
      border-radius: 25%;
    }
    to {
      border-radius: 3px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/checkbox.vue